<template>
  <a style="cursor: pointer">
    <div :class="['daily_bonus_prize', (index.valueOf() === 7) ? 'last' : (index.valueOf() < bonusDailyModal.loginStreak) ? 'alreadyopen' : '']">
      <div v-if="index.valueOf() < bonusDailyModal.loginStreak" class="daily_complete"><img class="" src="static/images/complete_icon.svg" alt=""></div>
      <h1 class="modal_sub">{{ getTranslations.home_daily_bonus_day }} {{ index }}</h1>
      <img :class="['pinicon ' + calculateIfPresentIsActiveOrNot(index)]" :src="['static/images/daily_' + index + '.svg']" alt="">
      <!-- add classes open bounce_box bounce_animation if the daily bonus is active -->
    </div>
  </a>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'bonus-daily-days',
  props: {
    index: Number,
  },
  data() {
    return {
      timer: 0,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    calculateIfPresentIsActiveOrNot(index) {
      if (index < this.bonusDailyModal.loginStreak) return 'open';
      else if (index === this.bonusDailyModal.loginStreak) return 'open bounce_box bounce_animation';
      return 'closed';
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/BonusDailyDays.vue